import { Stack, Typography } from '@lyearn/ui';

interface EmptyStateProps {
  height?: string;
}

const EmptyState = ({ height = 'h-[100px]' }: EmptyStateProps) => {
  return (
    <Stack alignItems="center" className={`w-full ${height}`} justifyContent="center">
      <Typography className="text-text-placeholder" variant="body-long-01">
        N/A
      </Typography>
    </Stack>
  );
};

export default EmptyState;
